import { Observable } from "rxjs";
import { TypeSearchingBy } from "../../model/TypeSearchingBy";
import { SearchEnrollmentDto } from "src/app/data/repositories/search/dto/search-enrollment.dto";
import { Metadata } from "src/app/base/model/data-body-request";
import { BaseRepository } from "src/app/data/repositories/base/base-repository";
import { ProcessedDataResponse } from "src/app/base/model/processed-data-response";

export abstract class SearchRepository extends BaseRepository {
    abstract searchEnrollment(
        params: {
            dataToSearch: string,
            typeSearchingBy: TypeSearchingBy,
            metadata: Metadata,
        }): Observable<ProcessedDataResponse<SearchEnrollmentDto>>;
}